module.exports = __webpack_public_path__ + "img/logo-STAIKA-tmp.c856a8d4.svg";